module.exports = __webpack_public_path__ + "static/abilia-footerBanner-80ccd6726a91355cff62eaae5eb4a86b.jpg";